export function infiniteLogoSlider() {
  if (document.querySelectorAll(".CB-infinite-logo-slider")) {
    const scrollers = document.querySelectorAll(".CB-infinite-logo-slider-instance");


    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }

    function addAnimation() {
      scrollers.forEach((scroller) => {
        scroller.setAttribute("data-animated", true);


        const scrollerInner = scroller.querySelector(".CB-infinite-logo-slider-instance-inner");
        const scrollerContent = [...scrollerInner.children];

        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          scrollerInner.appendChild(duplicatedItem);
        });
      });
    }
  }
}
